import { render } from "./CreateRequestBtn.vue?vue&type=template&id=9a411bec&ts=true"
import script from "./CreateRequestBtn.vue?vue&type=script&lang=ts"
export * from "./CreateRequestBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__